/**
 * The card and select styles the run page's sections share.
 */

import type { CSSProperties } from 'react';

export const card: CSSProperties = {
  border: '1px solid var(--border-hairline)',
  borderRadius: 'var(--radius-card)',
  padding: 'var(--space-md)',
  background: 'var(--surface-card)',
};

export const selectStyle: CSSProperties = {
  width: '100%',
  minHeight: 'var(--field-height)',
  padding: '10px 14px',
  borderRadius: 'var(--radius-input)',
  border: '1px solid var(--border-input)',
  background: 'var(--surface-card)',
  color: 'var(--text-primary)',
  font: 'var(--type-body-md)',
};
